import { createElement } from "../utils/create-elem.js";
/**
 * Creates a select dropdown with options.
 * @param {Object} params - The parameters for creating the select element.
 * @param {string[]=} params.fontElemClasses
 * @param {string[]=} params.classes - Optional array of CSS class names.
 * @param {HTMLElement=} params.parent - Optional parent element to append the select.
 * @param {Function} onClick
 * @returns {HTMLSelectElement} - The created select element.
 */
export function toolBtn(params) {
  const { fontElemClasses, parent, classes = [], onClick } = params;
  const elem = createElement({
    tag: "div",
    parent: parent,
    classes: classes,
    children: [createElement({ tag: "i", classes: fontElemClasses })],
  });
  elem.addEventListener("click", onClick);
  return elem;
}
